import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div style={s.wrap}>
      <div style={s.card}>
        <div style={s.code}>404</div>
        <h1 style={s.title}>Page not found</h1>
        <p style={s.subtitle}>
          The page you are looking for doesn't exist or has been moved.
        </p>
        <div style={s.actions}>
          <Link to="/" style={s.primaryBtn}>← Back to Home</Link>
          <Link to="/portfolios" style={s.secondaryBtn}>My portfolios</Link>
        </div>
      </div>
    </div>
  );
}

const s = {
  wrap: {
    minHeight: '60vh',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '40px 20px',
  },
  card: {
    textAlign: 'center', maxWidth: '460px',
    background: 'var(--surface-strong)',
    border: '1px solid var(--border)',
    borderRadius: '16px',
    padding: '40px 32px',
    boxShadow: 'var(--shadow)',
  },
  code: {
    fontSize: '64px', fontWeight: 900, lineHeight: 1,
    color: 'var(--accent)', marginBottom: '8px',
    letterSpacing: '-2px',
  },
  title: {
    margin: '0 0 12px', fontSize: '24px', fontWeight: 800,
    color: 'var(--text-primary)',
  },
  subtitle: {
    margin: '0 0 28px', fontSize: '14px', color: 'var(--text-secondary)',
    lineHeight: 1.5,
  },
  actions: {
    display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap',
  },
  primaryBtn: {
    background: 'var(--accent)', color: '#fff',
    padding: '10px 18px', borderRadius: '8px',
    fontWeight: 700, fontSize: '14px',
    textDecoration: 'none',
  },
  secondaryBtn: {
    background: 'var(--surface)', color: 'var(--text-primary)',
    border: '1px solid var(--border)',
    padding: '10px 18px', borderRadius: '8px',
    fontWeight: 700, fontSize: '14px',
    textDecoration: 'none',
  },
};
